import Faqs from './pages/Faqs';
import Index from './pages/Index';
import Aboutus from './pages/Aboutus';
import Contact from './pages/Contact';
import Gallery from './pages/Gallery';
import { Route, Routes } from 'react-router-dom';
import BusinessLoans from './pages/BusinessLoans';
import SmeLoans from './pages/SmeLoans';
import SalaryLoans from './pages/SalaryLoans';
import Termsofservice from './pages/Termsofservice';
import Career from './pages/Career';
import FormSubmission from './pages/FormSubmission';
// import CareerSubmission from './pages/CareerSubmission';

function App() {
  return (
    <>
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="aboutus" element={<Aboutus />} />
      <Route path="/contactus" element={<Contact />} />
      <Route path="/gallery" element={<Gallery />} />
      <Route path="/faqs" element={<Faqs />} />
      <Route path="/business-loans" element={<BusinessLoans />} />
      <Route path="/sme-loans" element={<SmeLoans />} />
      <Route path="/salary-loans" element={<SalaryLoans />} />
      <Route path="/terms-of-service" element={<Termsofservice />} />
      <Route path="/career" element={<Career />} />
      <Route path="/formsubmission" element={ <FormSubmission />} />
      {/* <Route path="/careersubmission" element={ <CareerSubmission />} /> */}
      {/* Error page */}
        <Route path="*" element={
          <div
            className='Error flex flex-col items-center justify-center text-center gap-8 w-full min-h-screen px-4 sm:px-16 md:px-32 lg:px-80 mx-auto'
            style={{
              backgroundImage: 'radial-gradient(gray 0px, transparent 1px)',
              backgroundSize: '20px 20px'
            }}
          >
            <div>
              <img src='../assets/404error.png' alt='404 error' className='w-16 h-16 mx-auto' />
            </div>
            <div className='text-3xl sm:text-4xl md:text-6xl font-semibold tracking-tighter capitalize'>
              <h2>oops 404 again! sorry, page not found.</h2>
            </div>
            <div className='font-roboto-mono'>
              <p className='-tracking-tighter lg:px-24 mx-auto'>Looks like nothing was found in this location. Check the url path entered or maybe try a search... </p>
            </div>
          </div>
        } />
    </Routes>
    </>
  );
}

export default App;
